// en, de, fr, pt
export default {
 en: {
  Dashboard: 'Dashboard',
  eCommerce: 'eCommerce',
  Apps: 'Apps',
  Todo: 'Todo',
  Chat: 'Chat',
  Email: 'Email',
  Calendar: 'Calendar',
  Shop: 'Shop',
  Cart: 'Cart',
  WishList: 'Wish List',
  Checkout: 'Checkout',
  UIElements: 'UI Elements',
  DataList: 'Data List',
  ListView: 'List View',
  ThumbView: 'Thumb View',
  Grid: 'Grid',
  Vuesax: 'Vuesax',
  Tailwind: 'Tailwind',
  Colors: 'Colors',
  Card: 'Card',
  Basic: 'Basic',
  Statistics: 'Statistics',
  Analytics: 'Analytics',
  CardActions: 'Card Actions',
  Table: 'Table',
  Components: 'Components',
  Alert: 'Alert',
  Avatar: 'Avatar',
  Badge: 'Badge',
  Breadcrumb: 'Breadcrumb',
  Button: 'Button',
  Chip: 'Chip',
  Collapse: 'Collapse',
  Dialogs: 'Dialogs',
  Divider: 'Divider',
  DropDown: 'DropDown',
  List: 'List',
  Loading: 'Loading',
  Navbar: 'Navbar',
  Notifications: 'Notifications',
  Pagination: 'Pagination',
  Popup: 'Popup',
  Progress: 'Progress',
  Sidebar: 'Sidebar',
  Slider: 'Slider',
  Tabs: 'Tabs',
  Tooltip: 'Tooltip',
  Upload: 'Upload',
  Forms: 'Forms',
  FormElements: 'Form Elements',
  Select: 'Select',
  Switch: 'Switch',
  Checkbox: 'Checkbox',
  Radio: 'Radio',
  Input: 'Input',
  NumberInput: 'Number Input',
  Textarea: 'Textarea',
  FormLayouts: 'Form Layouts',
  FormWizard: 'Form Wizard',
  FormValidation: 'Form Validation',
  Pages: 'Pages',
  Authentication: 'Authentication',
  Login: 'Login',
  Register: 'Register',
  ForgotPassword: 'Forgot Password',
  ResetPassword: 'Reset Password',
  LockScreen: 'Lock Screen',
  ComingSoon: 'Coming Soon',
  Error: 'Error',
  404: '404',
  500: '500',
  NotAuthorized: 'Not Authorized',
  Maintenance: 'Maintenance',
  Profile: 'Profile',
  Invoice: 'Invoice',
  FAQ: 'FAQ',
  Search: 'Search',
  KnowledgeBase: 'Knowledge Base',
  ChartsAndMaps: 'Charts & Maps',
  Charts: 'Charts',
  ApexCharts: 'Apex Charts',
  chartjs: 'chartjs',
  echarts: 'echarts',
  chartist: 'chartist',
  GoogleMap: 'Google Map',
  Extensions: 'Extensions',
  QuillEditor: 'Quill Editor',
  DragAndDrop: 'Drag & Drop',
  Datepicker: 'Datepicker',
  AccessControl: 'Access Control',
  EditorView: 'Editor View',
  AdminView: 'Admin View',
  I18n: 'I18n',
  Carousel: 'Carousel',
  Clipboard: 'Clipboard',
  ContextMenu: 'Context Menu',
  Others: 'Others',
  MenuLevels: 'Menu Levels',
  MenuLevel2p1: 'Menu Level 2.1',
  MenuLevel2p2: 'Menu Level 2.2',
  MenuLevel3p1: 'Menu Level 3.1',
  MenuLevel3p2: 'Menu Level 3.2',
  DisabledMenu: 'Disabled Menu',
  Support: 'Support',
  Documentation: 'Documentation',
  RaiseSupport: 'Raise Support',
  demoTitle: 'Card Title',
  demoText:
   'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',

  FunctionUnavailableNow: 'This function is unavailable for now',
  PleaseSelectInList: 'Please item in list',
  EmailIsAlreadyUsed: 'Email address is already in use.',
  RegisterDonePleaseVerifyEmail:
   'Create an account successfully, please verify your email address first.',
  PasswordResetUrlSent:
   'Password reset url has been sent to your email address.',

  Topics: 'Topics',
  Scoreboard: 'Scoreboard',

  Title: 'กรมสรรพสามิต',
  Home: 'หน้าหลัก',
  Monitoring: 'ระบบติดตามตำแหน่งเรือในโครงการ',
  RegistrationVessel: 'ลงทะเบียนเรือ',
  Reparation: 'แจ้งซ่อม',
  Resignation: 'ออกจากโครงการ',
  Accessories: 'แจ้งรับ-ติดตั้งอุปกรณ์',
  InstallationAccessories: 'ติดตั้งอุปกรณ์',
  RegistrationUser: 'จัดการผู้ใช้งาน',
  OilTransferRefinery: 'โรงกลั่น', //ข้อมูลการจำหน่ายน้ำมันของโรงกลั่น
  OilTransferTanker: 'เรือขนย้ายน้ำมัน', //ข้อมูลการรับ-จ่ายน้ำมันของเรือสถานีบริการน้ำมัน
  OilTransferForwardTanker: 'เรือสถานีบริการน้ำมัน',
  OilTransferVessel: 'เรือประมง',
  OilTransfer: 'ข้อมูลตรวจสอบปริมาณการจำหน่ายน้ำมัน',
  Setting: 'การตั้งค่า',
  Notification: 'การเเจ้งเตือนทั่วไป',
  GuardZoneNotification: 'การเเจ้งเตือนการเข้ารับน้ำมัน',
  Report: 'รายงาน',
  RefuelReport: 'รายงานสถานะการติดตามเรือประมง',
  AisLoss: 'สถานะการทำงานอุปกรณ์',
  BatteryStatus: 'สถานะอุปกรณ์สำรองข้อมูล',
  RefuelEvent: 'สถานะการเข้ารับน้ำมัน',
  VesselTrackingReport: 'รายงานการเดินเรือ',
  OilDistributionReport: 'รายงานการจำหน่ายน้ำมัน',
  VesselOwnerList: 'บัญชีรายชื่อเจ้าของเรือ',
  Behavior: 'พฤติกรรม',
  OverflowTransfer: 'การเติมน้ำมันเกินความจุถัง',
  MonthlyOccurrence: 'ความถี่ของการเข้ารับน้ำมัน',
  addVessel: {
   VesselDetail: 'VesselDetail',
   Applicant: 'Applicant',
   Name: 'Name',
   NaturalPerson: 'NaturalPerson',
   Juristic: 'Juristic',
   JointVenture: 'JointVenture',
   Movement: 'Movement',
   GovernmentAgency: 'GovernmentAgency',
   CardId: 'CardId Or CorporateNumber',
   AddressNumber: 'AddressNumber',
   PostalCode: 'PostalCode',
   SubDistrict: 'SubDistrict',
   District: 'District',
   Province: 'Province',
   PhoneNumber: 'PhoneNumber',
   Email: 'Email',
   CaptainName: 'CaptainName',
   VesselName: 'VesselName',
   PurposeUseVessel: 'วัตถุประสงค์ในการใช้เรือ',
   VesselNumber: 'หมายเลขทะเบียนเรือ',
   CityRegisteredVessel: 'เมืองท่าที่ขึ้นทะเบียนเรือ',
   CallSign: 'Call Sign',
   VesselMaterial: 'Vessel Material',
   SizeVessel: 'Size Vessel',
   Width: 'Width',
   Depth: 'Depth',
   TotalWeight: 'Total Weight',
   WeightOfItems: 'Weight of items',
   MachineType: 'MachineType',
   MachineName: 'MachineName',
   NumberOfMachines: 'NumberOfMachines',
   NumberOfCylinders: 'NumberOfCylinders',
   EngineSize: 'EngineSize',
   OilTankCapacity: 'OilTankCapacity',
   TankerCapacity: 'TankerCapacity',
   VesselType: 'VesselType',
   ExpireDate: 'ExpireDate',
   LicenseRegisteredVessel: 'LicenseRegisteredVessel',
   LicenseNumber: 'LicenseNumber',
   ToolType: 'ToolType',
   InstalledDevicePicture: 'InstalledDevicePicture',
   PictureOfWholeVessel_Right: 'PictureOfWholeVessel_Right',
   PictureOfWholeVessel_Left: 'PictureOfWholeVessel_Left',
   PointSettingAIS: 'PointSettingAIS',
   VesselRegistration: 'VesselRegistration',
   Consideration: 'Consideration',
   ExciseOfficerOpinion: 'ExciseOfficerOpinion',
   Approve: 'Approve',
   DoNotApprove: 'DoNotApprove',
   Sign: 'Sign',
   Position: 'Position',
   Date: 'Date',
   Order: 'Order',
  },

  //pdss
  title: 'ระบบตรวจสอบเฝ้าระวังการจำหน่ายน้ำมัน',
  subtitle: 'สำหรับชาวประมงในเขตต่อเนื่องของราชอาณาจักร',
  name: 'PDSS',
  home: 'หน้าหลัก',
  dashboard: 'แดชบอร์ด',
  report: 'รายงาน',
  notification: 'การเเจ้งเตือน',
  users: 'ผู้ใช้งาน',
  oilPriceLog: 'ราคาน้ำมัน',
  addOilPrice: 'เพิ่มราคาน้ำมัน',
  menu1: 'เมนู 1',
  menu2: 'เมนู 2',
  destinationType: 'ปลายทาง',
  search: 'ค้นหา',
  download: 'ดาวน์โหลด',
  message: {
   hello: 'สวัดดี',
  },
  greenDiesel: 'น้ำมันเขียว',
  domesticOil: 'น้ำมันในประเทศ',
  exportOil: 'น้ำมันส่งออกนอกประเทศ',
  totalOil: 'ยอดรวมน้ำมัน',
  TotalIsExciseRate: 'มูลค่าน้ำมัน',
  TotalIsExciseExemption: 'มูลค่าที่ขอยกเว้น/คืนภาษี',
  OilPrice: 'ราคาน้ำมัน/ลิตร ',
  PercentOfLost: 'มูลค่า 1% กรณีสูญหาย',
  RefineryIRPC: 'โรงกลั่น IRPC',
  RefinerySPRC: 'โรงกลั่น SPRC',
  RefineryTOP: 'โรงกลั่น TOP',
  RefineryBCP: 'โรงกลั่น BCP',
  RefineryPTTGC: 'โรงกลั่น PTTGC',
  RefineryESSO: 'โรงกลั่น ESSO',
  Liter: 'ล.',
  Baht: 'บ.',
  Graphics: 'กราฟิกแสดงผล',
  No: 'แบบที่',
  RadarChart: 'กราฟวงกลม',
  SunBurstChart: 'กราฟดวงอาทิตย์',
  StackedColumnChart: 'แผนภูมิยอดรวมน้ำมัน',
  OilTypeStackedColumnChart: 'แผนภูมิประเภทน้ำมัน',
  LineChart: 'กราฟเส้น',
  ShipmentTable: {
   Shipment: 'ตารางการจัดส่งน้ำมัน',
   Id: 'ลำดับ',
   MemberCode: 'รหัสสมาชิก',
   RegisterNumber: 'ทะเบียนเรือ',
   TankerName: 'เรือสถานีบริการน้ำมัน',
   VesselName: 'เรือประมง',
   TransferVolume: 'ปริมาณการจำหน่ายน้ำมัน',
   TransferStart: 'วันที่/เวลาเริ่ม',
  },
  TankerTable: {
   Id: 'ลำดับ',
   MMSI: 'MMSI',
   TankerName: 'ชื่อเรือบรรทุกน้ำมัน',
   TransferVolume: 'ปริมาณน้ำมัน',
   TransferTotalVolume: 'ปริมาณน้ำมันรวม',
   Capacity: 'ความจุถังน้ำมัน',
   TransferStart: 'วันที่ออกเดินทาง',
   OilType: 'ประเภทน้ำมัน',
  },
  RefineryTable: {
   Id: 'ลำดับ',
   RefineryName: 'โรงกลั่น',
   TankerName: 'ชื่อเรือบรรทุกน้ำมัน',
   TransferVolume: 'ปริมาณน้ำมัน',
   TransferStart: 'วันที่ออกเดินทาง',
   Detail: 'รายละเอียด',
   ReadAt: 'อ่านเมื่อ',
  },
  profile: 'ข้อมูลส่วนตัว',
  editProfile: 'แก้ไขข้อมูลส่วนตัว',
  information: 'ข้อมูล',
  profilePage: {
   joined: 'เข้าร่วม',
   lives: 'อาศัย',
   email: 'อีเมล',
   website: 'เว็บไซต์',
   username: 'ชื่อผู้ใช้',
   firstName: 'ชื่อ',
   lastName: 'นามสกุล',
   dateOfBirth: 'วันเดือนปีเกิด',
   address: 'ที่อยู่',
   city: 'เมือง',
   country: 'ประเทศ',
   password: 'รหัสผ่าน',
   changePassword: 'เปลี่ยนรหัสผ่าน',
   changePasswordMessage: 'เปลี่ยนรหัสผ่านหรือกู้คืนรหัสผ่านปัจจุบันของคุณ',
   currentPassword: 'รหัสผ่านปัจจุบัน',
   newPassword: 'รหัสผ่านใหม่',
   confirmPassword: 'ยื่นยันรหัสผ่าน',
   nickName: 'ชื่อเล่น',
   telephone: 'โทรศัพท์',
   gender: 'เพศ',
   male: 'ชาย',
   female: 'หญิง',
  },
  addUser: 'เพิ่มผู้ใช้งาน',
  editUser: 'แก้ไขข้อมูลผู้ใช้งาน',
  input: 'นำเข้า',
 },
 th: {
  excise: {
   LearningTopic: 'หัวข้อแบบเรียน',
   AboutExcise: 'ข้อมูลเกี่ยวกับกรมสรรพสามิต',
   LISTOFDOCUMENTSANDFORMS: 'รายชื่อเอกสารและฟอร์มที่ใช้ในการปฏิบัติงาน',
   GoodsAndServices:
    'รายชื่อสินค้า กิจการ และบริการที่ระบุไว้ในบัญชีพิกัดอัตราภาษีสรรพสามิต',
   OilAndPetroleumProducts: 'สินค้าน้ำมันและผลิตภัณฑ์น้ำมัน',
   Beverages: 'สินค้าเครื่องดื่ม',
   ElectronicAppliances: 'สินค้าเครื่องไฟฟ้า',
   Battery: 'แบตเตอรี่',
   GlassAndGlassware: 'สินค้าแก้วและเครื่องแก้ว',
   Automobiles: 'สินค้ารถยนต์',
   Motorcycle: 'รถจักรยานยนต์',
   Boats: 'สินค้าเรือ',
   PerfumeryAndCosmetics: 'สินค้าผลิตภัณฑ์เครื่องหอมและเครื่องสำอาง',
   CarpetsAndOtherFloorCoveringTextiles: 'สินค้าพรมและสิ่งทอปูพื้นอื่นๆ',
   MarbleAndGraniteProducts: 'สินค้าหินอ่อนและหินแกรนิต',

   AboutExcise: '',
   DivisionAndPosition: '',
   Vocabulary: '',
   Pronunciation: '',
   GeneralEnglish1: '',
   GeneralEnglish2: '',
   EnglishAtWork: '',
   KhoPhorRecap: '',
   UsefulLink: '',
  },
  Dashboard: 'ภาพรวม',
  eCommerce: 'eCommerce',
  Apps: 'Apps',
  Todo: 'Todo',
  Chat: 'Chat',
  Email: 'Email',
  Calendar: 'Calendar',
  Shop: 'Shop',
  Cart: 'Cart',
  WishList: 'Wish List',
  Checkout: 'Checkout',
  UIElements: 'UI Elements',
  DataList: 'Data List',
  ListView: 'List View',
  ThumbView: 'Thumb View',
  Grid: 'Grid',
  Vuesax: 'Vuesax',
  Tailwind: 'Tailwind',
  Colors: 'Colors',
  Card: 'Card',
  Basic: 'Basic',
  Statistics: 'Statistics',
  Analytics: 'Analytics',
  CardActions: 'Card Actions',
  Table: 'Table',
  Components: 'Components',
  Alert: 'แจ้งเตือน',
  Avatar: 'Avatar',
  Badge: 'Badge',
  Breadcrumb: 'Breadcrumb',
  Button: 'Button',
  Chip: 'Chip',
  Collapse: 'Collapse',
  Dialogs: 'Dialogs',
  Divider: 'Divider',
  DropDown: 'DropDown',
  List: 'List',
  Loading: 'Loading',
  Navbar: 'Navbar',
  Notifications: 'Notifications',
  Pagination: 'Pagination',
  Popup: 'Popup',
  Progress: 'Progress',
  Sidebar: 'Sidebar',
  Slider: 'Slider',
  Tabs: 'Tabs',
  Tooltip: 'Tooltip',
  Upload: 'Upload',
  Forms: 'Forms',
  FormElements: 'Form Elements',
  Select: 'Select',
  Switch: 'Switch',
  Checkbox: 'Checkbox',
  Radio: 'Radio',
  Input: 'Input',
  NumberInput: 'Number Input',
  Textarea: 'Textarea',
  FormLayouts: 'Form Layouts',
  FormWizard: 'Form Wizard',
  FormValidation: 'Form Validation',
  Pages: 'Pages',
  Authentication: 'Authentication',
  Login: 'Login',
  Register: 'Register',
  ForgotPassword: 'Forgot Password',
  ResetPassword: 'Reset Password',
  LockScreen: 'Lock Screen',
  ComingSoon: 'Coming Soon',
  Error: 'Error',
  404: '404',
  500: '500',
  NotAuthorized: 'Not Authorized',
  Maintenance: 'Maintenance',
  Profile: 'Profile',
  Invoice: 'Invoice',
  FAQ: 'FAQ',
  Search: 'Search',
  KnowledgeBase: 'Knowledge Base',
  ChartsAndMaps: 'Charts & Maps',
  Charts: 'Charts',
  ApexCharts: 'Apex Charts',
  chartjs: 'chartjs',
  echarts: 'echarts',
  chartist: 'chartist',
  GoogleMap: 'Google Map',
  Extensions: 'Extensions',
  QuillEditor: 'Quill Editor',
  DragAndDrop: 'Drag & Drop',
  Datepicker: 'Datepicker',
  AccessControl: 'Access Control',
  EditorView: 'Editor View',
  AdminView: 'Admin View',
  I18n: 'I18n',
  Carousel: 'Carousel',
  Clipboard: 'Clipboard',
  ContextMenu: 'Context Menu',
  Others: 'Others',
  MenuLevels: 'Menu Levels',
  MenuLevel2p1: 'Menu Level 2.1',
  MenuLevel2p2: 'Menu Level 2.2',
  MenuLevel3p1: 'Menu Level 3.1',
  MenuLevel3p2: 'Menu Level 3.2',
  DisabledMenu: 'Disabled Menu',
  Support: 'Support',
  Documentation: 'Documentation',
  RaiseSupport: 'Raise Support',
  demoTitle: 'Card Title',
  demoText:
   'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',

  FunctionUnavailableNow: 'ฟังก์ชันยังไม่เปิดใช้งาน',
  PleaseSelectInList: 'ต้องเลือกรายการในลิสต์ก่อน',

  EmailIsAlreadyUsed: 'อีเมล์นี้ได้ถูกใช้ไปแล้ว',
  RegisterDonePleaseVerifyEmail: 'สมัครสมาชิกสำเร็จ กรุณายืนยันอีเมล์ของคุณ',
  PasswordResetUrlSent:
   'ลิงค์สำหรับรีเซ็ตรหัสผ่านได้ถูกส่งไปที่อีเมล์ของท่านแล้ว',

  Title: 'กรมสรรพสามิต',
  Home: 'หน้าหลัก',
  RegistrationVessel: 'ลงทะเบียนเรือ',
  Reparation: 'แจ้งซ่อม',
  Resignation: 'ออกจากโครงการ',
  Accessories: 'แจ้งรับ-ติดตั้งอุปกรณ์',
  InstallationAccessories: 'ติดตั้งอุปกรณ์',
  addVessel: {
   VesselDetail: 'รายละเอียดเรือ',
   Applicant: 'ผู้ยื่นคำขอ (เจ้าของเรือ)',
   Name: 'ชื่อ',
   NaturalPerson: 'บุคคลธรรมดา',
   Juristic: 'นิติบุคคล',
   JointVenture: 'กิจกรรมร่วมทุน/กิจการร่วมค้า',
   Movement: 'คณะบุคคล',
   GovernmentAgency: 'หน่วยงานราชการ/อื่นๆ ระบุ',
   CardId: 'เลขบัตรประชาชน / เลขนิติบุคคล',
   AddressNumber: 'ที่อยู่/ที่ตั้งสำนักงานใหญ่เลขที่',
   PostalCode: 'รหัสไปรษณีย์',
   SubDistrict: 'ตำบล',
   District: 'อำเภอ',
   Province: 'จังหวัด',
   PhoneNumber: 'เบอร์โทร',
   Email: 'อีเมล',
   CaptainName: 'ชื่อผู้คุมเรือ / ไต๋เรือ / ผู้ทำการประมง',
   VesselName: 'ชื่อเรือ',
   PurposeUseVessel: 'วัตถุประสงค์ในการใช้เรือ',
   VesselNumber: 'หมายเลขทะเบียนเรือ',
   CityRegisteredVessel: 'เมืองท่าที่ขึ้นทะเบียนเรือ',
   CallSign: 'Call Sign',
   VesselMaterial: 'Vessel Material',
   SizeVessel: 'Size Vessel',
   Width: 'ความกว้าง',
   Depth: 'ความลึก',
   TotalWeight: 'ตันกรอส',
   WeightOfItems: 'ตันเนต',
   MachineType: 'ชนิดเครื่องจักร',
   MachineName: 'ชื่อเครื่อง',
   NumberOfMachines: 'จำนวนเครื่อง',
   NumberOfCylinders: 'จำนวนสูบ',
   EngineSize: 'ขนาดเครื่องยนต์',
   OilTankCapacity: 'ปริมาณความจุถังน้ำมัน',
   TankerCapacity: 'ปริมาณความจุถังบรรทุกน้ำมัน',
   VesselType: 'ประเภทเรือ',
   ExpireDate: 'หมดอายุวันที่',
   LicenseRegisteredVessel: 'ใบอนุญาตใช้เรือจดทะเบียนล่าสุดวัน',
   LicenseNumber: 'สำหรับเรือประมง หมายเลขอัชญาบัตร / ใบอนุญาตทำการประมง',
   ToolType: 'ประเภทเครื่องมือทำการประมง',
   InstalledDevicePicture: 'รูปอุปกรณ์ที่ติดตั้ง',
   PictureOfWholeVessel_Right: 'รูปเรือทั้งลำ (ท้างด้านขวา)',
   PictureOfWholeVessel_Left: 'รูปเรือทั้งลำ (ท้างด้านซ้าย)',
   PointSettingAIS: 'จุดที่จะขอติดตัวอุปกรณ์ระบบ AIS',
   VesselRegistration: 'ชื่อเรือ/ทะเบียนเรือ',
   Consideration: 'การพิจารณา',
   ExciseOfficerOpinion: 'ความคิดเห็นเจ้าพนักงานสรรพสามิต',
   Approve: 'เห็นควรอนุมัติ',
   DoNotApprove: 'ไม่เห็นควรอนุมัติ เนื่องจาก',
   Sign: 'ลงชื่อ',
   Position: 'ตำแหน่ง',
   Date: 'วันที่',
   Order: 'คำสั่ง',
  },
  //pdss
  title: 'ระบบตรวจสอบเฝ้าระวังการจำหน่ายน้ำมัน',
  subtitle: 'สำหรับชาวประมงในเขตต่อเนื่องของราชอาณาจักร',
  name: 'PDSS',
  home: 'หน้าหลัก',
  dashboard: 'แดชบอร์ด',
  report: 'รายงาน',
  notification: 'การเเจ้งเตือน',
  users: 'ผู้ใช้งาน',
  oilPriceLog: 'ราคาน้ำมัน',
  addOilPrice: 'เพิ่มราคาน้ำมัน',
  menu1: 'เมนู 1',
  menu2: 'เมนู 2',
  destinationType: 'ปลายทาง',
  search: 'ค้นหา',
  download: 'ดาวน์โหลด',
  message: {
   hello: 'สวัดดี',
  },
  greenDiesel: 'น้ำมันเขียว',
  domesticOil: 'น้ำมันในประเทศ',
  exportOil: 'น้ำมันส่งออกนอกประเทศ',
  totalOil: 'ยอดรวมน้ำมัน',
  TotalIsExciseRate: 'มูลค่าน้ำมัน',
  TotalIsExciseExemption: 'มูลค่าที่ขอยกเว้น/คืนภาษี',
  OilPrice: 'ราคาน้ำมัน/ลิตร ',
  PercentOfLost: 'มูลค่า 1% กรณีสูญหาย',
  RefineryIRPC: 'โรงกลั่น IRPC',
  RefinerySPRC: 'โรงกลั่น SPRC',
  RefineryTOP: 'โรงกลั่น TOP',
  RefineryBCP: 'โรงกลั่น BCP',
  RefineryPTTGC: 'โรงกลั่น PTTGC',
  RefineryESSO: 'โรงกลั่น ESSO',
  Liter: 'ล.',
  Baht: 'บ.',
  Graphics: 'กราฟิกแสดงผล',
  No: 'แบบที่',
  RadarChart: 'กราฟวงกลม',
  SunBurstChart: 'กราฟดวงอาทิตย์',
  StackedColumnChart: 'แผนภูมิยอดรวมน้ำมัน',
  OilTypeStackedColumnChart: 'แผนภูมิประเภทน้ำมัน',
  LineChart: 'กราฟเส้น',
  ShipmentTable: {
   Shipment: 'ตารางการจัดส่งน้ำมัน',
   Id: 'ลำดับ',
   MemberCode: 'รหัสสมาชิก',
   RegisterNumber: 'ทะเบียนเรือ',
   TankerName: 'เรือสถานีบริการน้ำมัน',
   VesselName: 'เรือประมง',
   TransferVolume: 'ปริมาณการจำหน่ายน้ำมัน',
   TransferStart: 'วันที่/เวลาเริ่ม',
  },
  TankerTable: {
   Id: 'ลำดับ',
   MMSI: 'MMSI',
   TankerName: 'ชื่อเรือบรรทุกน้ำมัน',
   TransferVolume: 'ปริมาณน้ำมัน',
   TransferTotalVolume: 'ปริมาณน้ำมันรวม',
   Capacity: 'ความจุถังน้ำมัน',
   TransferStart: 'วันที่ออกเดินทาง',
   OilType: 'ประเภทน้ำมัน',
  },
  RefineryTable: {
   Id: 'ID',
   RefineryName: 'โรงกลั่น',
   TankerName: 'ชื่อเรือบรรทุกน้ำมัน',
   TransferVolume: 'ปริมาณน้ำมัน',
   TransferStart: 'วันที่ออกเดินทาง',
   Detail: 'รายละเอียด',
   ReadAt: 'อ่านเมื่อ',
  },
  profile: 'ข้อมูลส่วนตัว',
  editProfile: 'แก้ไขข้อมูลส่วนตัว',
  information: 'ข้อมูล',
  profilePage: {
   joined: 'เข้าร่วม',
   lives: 'อาศัย',
   email: 'อีเมล',
   website: 'เว็บไซต์',
   username: 'ชื่อผู้ใช้',
   firstName: 'ชื่อ',
   lastName: 'นามสกุล',
   dateOfBirth: 'วันเดือนปีเกิด',
   address: 'ที่อยู่',
   city: 'เมือง',
   country: 'ประเทศ',
   password: 'รหัสผ่าน',
   changePassword: 'เปลี่ยนรหัสผ่าน',
   changePasswordMessage: 'เปลี่ยนรหัสผ่านหรือกู้คืนรหัสผ่านปัจจุบันของคุณ',
   currentPassword: 'รหัสผ่านปัจจุบัน',
   newPassword: 'รหัสผ่านใหม่',
   confirmPassword: 'ยื่นยันรหัสผ่าน',
   nickName: 'ชื่อเล่น',
   telephone: 'โทรศัพท์',
   gender: 'เพศ',
   male: 'ชาย',
   female: 'หญิง',
  },
  addUser: 'เพิ่มผู้ใช้งาน',
  editUser: 'แก้ไขข้อมูลผู้ใช้งาน',
  input: 'นำเข้า',
 },
}
